const typesColors = {
  normal: "#0be881",
  fire: "#EA2027",
  fighting: "#485460",
  water: "#0fbcf9",
  flying: "#34e7e4",
  grass: "#44bd32",
  poison: "#130f40",
  electric: "#ffdd59",
  ground: "#c0392b",
  psychic: "#ef5777",
  rock: "#535c68",
  ice: "#c7ecee",
  bug: "#C4E538",
  dragon: "#3c40c6",
  ghost: "#485460",
  dark: "#1e272e",
  steel: "darkgray",
  faire: "salmon",
};

export default typesColors;
